import { memo } from 'react';

import { AvatarScene } from '@/components/AvatarScene';
import type { IAvatarOptions } from '../AvatarOptionsPanel/types';
import BackgroundColor from '@/assets/images/Background.svg?component';
import IconRotate from '@/assets/images/icons/icon-rotate.svg?component';
import { ContainerAvatar, WrapperIconRotate } from './AvatarCreator.styles';
import BackgroundPattern from '@/assets/images/BackgroundPattern.svg?component';

type AvatarPlaceProps = {
  onSubmit: (image: File) => void;
  options: IAvatarOptions;
  baseModelUrl: string;
  submitting: boolean;
  large: boolean;
  color: string;
  tab: string;
};

const AvatarPlace = ({
  baseModelUrl,
  submitting,
  onSubmit,
  options,
  color,
  large,
  tab
}: AvatarPlaceProps) => (
  <ContainerAvatar color={color} large={large}>
    <BackgroundColor />
    {color && <BackgroundPattern />}

    <WrapperIconRotate>
      <IconRotate />
    </WrapperIconRotate>

    {baseModelUrl && (
      <AvatarScene
        baseModelUrl={baseModelUrl}
        submitting={submitting}
        onSubmit={onSubmit}
        options={options}
        large={large}
        tab={tab}
      />
    )}
  </ContainerAvatar>
);

export default memo(AvatarPlace);
